import { logger } from '../logger';
export function withLogAction(action, command) {
    return (...args) => {
        const res = command(...args);
        if (res)
            logger.action({ action, source: 'keymap' });
        return res;
    };
}
